export default {
  user: null,
  authenticated: false
}
